import { MyLocation } from '@material-ui/icons';

import { GeotrackingList } from './GeotrackingList';

export const options = { label: 'Geotracking' };

export const icon = MyLocation;

export const list = GeotrackingList;
